import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import { CSSTransition } from 'react-transition-group';
import { useOutsideClickHandler } from '../../useDetectClickOut';
import ExitModalWarning from './exitModalWarning';
import './modal.css';

type modalProps = {
	visible: boolean;
	isChanged: boolean;
	setIsChanged: (isChanged: boolean) => void;
	setModalOpen: (isOpen: boolean) => void;
	isWarnModalOpen: boolean;
	setIsWarnModalOpen: (isOpen: boolean) => void;
};

// eslint-disable-next-line max-statements
const ParentModal: FunctionComponent<modalProps> = (props) => {
	const wrapperRef = useRef(null) as any;

	useOutsideClickHandler(
		wrapperRef,
		props.setModalOpen,
		props.setIsWarnModalOpen,
		props.isChanged
	);

	return (
		<CSSTransition
			in={props.visible}
			timeout={400}
			unmountOnExit
			classNames="modal"
		>
			{(state) => (
				<div
					id="defaultModal"
					aria-hidden="true"
					className="overflow-y-auto overflow-x-hidden backdrop-blur-md fixed z-30
							  w-full inset-0 h-modal h-full"
				>
					<ExitModalWarning
						title={'Discard changes'}
						text={'Are you sure you want to discard your changes?'}
						setModalOpen={props.setIsWarnModalOpen}
						setParentModalVisibility={() => props.setModalOpen(false)}
						setIsChanged={props.setIsChanged}
						visible={props.isWarnModalOpen}
					/>
					<div className="absolute inset-0 w h-full w-full opacity-50 bg-black" />
					<div ref={wrapperRef} className="mt-20">
						{props.children}
					</div>
				</div>
			)}
		</CSSTransition>
	);
};

export default ParentModal;
